import axios from "axios";
const baseUrl = process.env.REACT_APP_BASE_URL;
//Get Method
export let GetMethod = async (url, header, queryParams = {}) => {
  let getResponse = await axios.get(baseUrl + url, {
    headers: header,
    params: queryParams,
  });
  return getResponse ? getResponse.data : null;
};

//Post Method
export let PostMethod = async (url, data, header) => {
  let postData = await axios.post(baseUrl + url, data, {
    headers: header,
  });
  return postData ? postData.data : null;
};
